import { useState } from "react";
import { toast } from "react-toastify";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import {
  createNewCredit,
  createNewCreditCat,
  deleteCredit,
  deleteCreditCategory,
  editCredit,
  editCreditCat,
  getCreditDetail,
  getCreditList,
  getCreditListByClient,
  getListCreditOnTime,
  getCreditListMasseClient,
  setMasseList,
  updateMasseCredit,
  listTransactions,
  setListTrans,
  updateTransactionSlice,
  closeCredit,
  creditPayFastSlice,
  getListCreditDelay,
  creditTransformSlice,
  setDelayList,
  statisticData
} from "../store/slices/creditSlice";
import { useAppDispatch, useAppSelector } from "./index";

// import { getCreditCategoriesList } from "../store/slices/creditCategorySlice";

const useCreditManagement = () => {
  const [open, setOpen] = useState(false);
  const [openOut, setOpenOut] = useState(false);
  const [openCat, setOpenCat] = useState(false);
  const [openMasse, setOpenMasse] = useState(false);
  const [data, setData] = useState({});
  const [dataCat, setDataCat] = useState({});
  const [tab, setTab] = useState("1");
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [deleteModalContent, setDeleteModalContent] = useState("");
  const [checked, setChecked] = useState({});
  const [dataEdit, setDataEdit] = useState({});
  const [openEdit, setOpenEdit] = useState(false);
  const location = useLocation();
  const handleChecked = event => {
    setChecked(event.target.checked);
  };

  const {
    list,
    listByClient,
    metaData,
    listMasseClient,
    credit,
    listTrans,
    listOnTime,
    listDelay,
    statistic
  } = useAppSelector(state => state.credit);

  // const { list: creditCategories = [] } = useAppSelector(
  //   state => state.creditCategory
  // );
  const dispatch = useAppDispatch();

  const creditDetail = async id => {
    setLoadingDetail(true);
    try {
      await dispatch(getCreditDetail(id));
    } finally {
      setLoadingDetail(false);
    }
  };
  const updateTransaction = async (creditId, transactionId, dataUpdate) => {
    // setLoadingDetail(true);
    try {
      const newData = {
        transactionId,
        data: dataUpdate
      };
      const message = dataUpdate.isPaid
        ? "Trả tiền thành công"
        : "Hủy trả tiền thành công";
      const res = await dispatch(updateTransactionSlice(newData));
      const success = !res.payload?.error;
      if (!success) {
        toast.error(res.payload?.error?.message);
        // await dispatch(listTransactions(creditId));
      } else {
        toast.success(message);
        await dispatch(getCreditDetail(creditId));
        await dispatch(listTransactions(creditId));
        const params = queryString.parse(location.search);
        const isDelay = params && params.status === "delay";
        if (isDelay) {
          const filter = "?status=delay";
          await dispatch(getCreditListByClient(filter));
          await dispatch(getListCreditDelay());
        } else {
          await dispatch(getCreditListByClient());
        }
        await dispatch(statisticData());
      }
    } finally {
      // setLoading(false);
    }
  };

  const updateListTrans = (id, field, newValue) => {
    const newArray = JSON.parse(JSON.stringify(listTrans));
    const findIndex = newArray.findIndex(item => item.id === id);
    if (field === "amount") {
      newValue = parseInt(newValue.replace(/[^\d\\.]/g, "")) || "";
    }
    newArray[findIndex][field] = newValue;
    dispatch(setListTrans(newArray));
  };
  const creditPayFast = async (creditId, dataUpdate) => {
    // setLoadingDetail(true);
    try {
      const newData = {
        creditId,
        data: dataUpdate
      };
      const res = await dispatch(creditPayFastSlice(newData));
      const success = !res.payload?.error;
      if (!success) {
        toast.error(res.payload?.error?.message);
        // await dispatch(listTransactions(creditId));
      } else {
        toast.success("Trả tiền nhanh thành công");
        await dispatch(statisticData());
        // await dispatch(getCreditDetail(creditId));
        // await dispatch(listTransactions(creditId));
        // dispatch(getCreditListByClient());
      }
    } finally {
      // setLoading(false);
    }
  };

  const getListTransactions = async loanId => {
    setLoading(true);
    try {
      await dispatch(listTransactions(loanId));
    } finally {
      setLoading(false);
    }
  };
  const getCreditCategories = async () => {
    // setLoading(true);
    try {
      await dispatch(getCreditCategoriesList());
    } finally {
      // setLoading(false);
    }
  };

  const getList = async () => {
    setLoading(true);
    try {
      await dispatch(getCreditList());
    } finally {
      setLoading(false);
    }
  };

  const getListByClient = async (filter = "") => {
    setLoading(true);
    try {
      await dispatch(getCreditListByClient(filter));
    } finally {
      setLoading(false);
    }
  };

  const getCreditOnTime = async () => {
    // setLoading(true);
    try {
      await dispatch(getListCreditOnTime());
    } finally {
      // setLoading(false);
    }
  };
  const getCreditDelay = async () => {
    // setLoading(true);
    try {
      await dispatch(getListCreditDelay());
    } finally {
      // setLoading(false);
    }
  };

  const getListMasseClient = async clientId => {
    setLoading(true);
    try {
      return await dispatch(getCreditListMasseClient(clientId));
    } finally {
      setLoading(false);
    }
  };

  const createCredit = async (creditData, actions, handleCloseFunc) => {
    let success = false;
    try {
      const res = await dispatch(createNewCredit(creditData));
      success = !res.payload?.error;
      if (!success) {
        actions.setErrors(res.payload?.error || {});
        actions.setSubmitting(true);
        toast.error(res.payload?.error?.message);
      } else {
        toast.success("Tạo hợp đồng thành công");
        handleCloseFunc();
        await dispatch(getCreditListByClient());
        await dispatch(statisticData());
      }
      actions.setSubmitting(false);
      Promise.resolve();
    } finally {
      console.log("Create credit action completed");
    }
  };

  const createCreditCat = async (creditCatData, actions) => {
    try {
      const res = await dispatch(createNewCreditCat(creditCatData));
      const { errors } = res.payload;
      if (errors && Object.keys(errors).length) {
        if (errors.frontend_url && !errors.email) {
          errors.email = errors.frontend_url;
        }
        actions.setErrors(errors);
      } else {
        setOpenCat(false);
        await dispatch(getCreditCategoriesList());
        toast.success("Tạo hợp đồng thành công");
      }
      actions.setSubmitting(false);
      Promise.resolve();
    } finally {
      // setOpen(false);
    }
  };

  const edit = async (creditData, actions) => {
    try {
      const res = await dispatch(editCredit(creditData));
      const success = !res.payload?.error;
      if (!success) {
        // actions.setErrors(errors);
        actions.setSubmitting(true);
        toast.error(res.payload?.error?.message);
      } else {
        setOpen(false);
        toast.success(" Cập nhật thành công");
        const params = queryString.parse(location.search);
        const isDelay = params && params.status === "delay";
        if (isDelay) {
          const filter = "?status=delay";
          await dispatch(getCreditListByClient(filter));
        } else {
          await dispatch(getCreditListByClient());
        }
        await dispatch(statisticData());
      }
      actions.setSubmitting(false);
      Promise.resolve();
    } finally {
      // setOpen(false);
    }
  };

  const editCategory = async (creditData, actions) => {
    try {
      const res = await dispatch(editCreditCat(creditData));

      const { errors } = res.payload;
      if (errors && Object.keys(errors).length) {
        if (errors.frontend_url && !errors.email) {
          errors.email = errors.frontend_url;
        }
        actions.setErrors(errors);
      } else {
        setOpenCat(false);
        await dispatch(getCreditCategoriesList());
        toast.success("Thành công");
      }
      actions.setSubmitting(false);
      Promise.resolve();
    } finally {
      // setOpen(false);
    }
  };

  const remove = async creditId => {
    if (!creditId) return;
    try {
      const res = await dispatch(deleteCredit(creditId));
      const success = !res.payload?.error;
      if (!success) {
        toast.error(res.payload?.error?.message);
      } else {
        toast.success("Xóa thành công");
        const params = queryString.parse(location.search);
        const isDelay = params && params.status === "delay";
        if (isDelay) {
          const filter = "?status=delay";
          const newDayList = [...listDelay].filter(
            item => item.id !== creditId
          );
          dispatch(setDelayList(newDayList));
          await dispatch(getCreditListByClient(filter));
        } else {
          await dispatch(getCreditListByClient());
        }
        await dispatch(statisticData());
        // const filter = params.status ? `?status=${params.status}` : "";
      }
      Promise.resolve();
    } finally {
      setOpenModalDelete(false);
    }
  };
  const creditTransform = async (dataTransform, creditData, callback) => {
    const creditId = creditData.id;
    if (!creditId) return;
    try {
      delete dataTransform.customerName;
      delete dataTransform.notes;
      const res = await dispatch(
        creditTransformSlice({ creditId, data: dataTransform })
      );
      const success = !res.payload?.error;
      if (!success) {
        toast.error(res.payload?.error?.message);
      } else {
        toast.success("Gia hạn thành công");
        const newDayList = [...listDelay].filter(item => item.id !== creditId);
        dispatch(setDelayList(newDayList));
        const params = queryString.parse(location.search);
        const isDelay = params && params.status === "delay";
        if (isDelay) {
          const filter = "?status=delay";
          await dispatch(getCreditListByClient(filter));
        } else {
          await dispatch(getCreditListByClient());
        }
        callback();
      }
      Promise.resolve();
    } finally {
      // setOpenModalDelete(false);
    }
  };

  const removeCategory = async categoryId => {
    if (!categoryId) return;

    try {
      await dispatch(deleteCreditCategory(categoryId));
      await dispatch(getCreditCategoriesList());
      toast.success("Thành công");
    } finally {
      setOpenModalDelete(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleOutClose = () => {
    setOpenOut(false);
  };

  const handleCloseCat = () => {
    setOpenCat(false);
  };
  const creditClose = async (creditId, callback) => {
    if (!creditId) return;
    try {
      const res = await dispatch(
        closeCredit({
          id: creditId,
          status: "closed"
        })
      );
      const success = !res.payload?.error;
      if (!success) {
        toast.error(res.payload?.error?.message);
        // await dispatch(listTransactions(creditId));
      } else {
        toast.success("Đóng hợp đồng thành công");
        const params = queryString.parse(location.search);
        const isDelay = params && params.status === "delay";
        if (isDelay) {
          const newDayList = [...listDelay].filter(
            item => item.id !== creditId
          );
          dispatch(setDelayList(newDayList));
          const filter = "?status=delay";
          await dispatch(getCreditListByClient(filter));
        } else {
          await dispatch(getCreditListByClient());
        }
        await dispatch(statisticData());
      }
      callback();
      Promise.resolve();
    } finally {
      setOpenCat(false);
    }
  };
  const handleCloseModalDelete = () => {
    setOpenModalDelete(false);
  };

  const handleOpenModalDelete = (content, creditId) => {
    setOpenModalDelete(true);
    setDeleteId(creditId);
    setDeleteModalContent(content);
  };

  const handleOpen = (dataCredit = {}, activeTab = tab) => {
    setOpen(true);
    setData(dataCredit);
    setTab(activeTab);
  };

  const handleOpenOut = (dataCredit = {}, activeTab = tab) => {
    setOpenOut(true);
    setData(dataCredit);
    setTab(activeTab);
  };

  const handleOpenCat = (dataCreditCat = {}, activeTab = tab) => {
    setOpenCat(true);
    setDataCat(dataCreditCat);
    setTab(activeTab);
  };

  const handleOpenEdit = (editData = {}) => {
    setOpenEdit(true);
    setDataEdit(editData);
  };
  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const handleOpenMasse = () => {
    setOpenMasse(true);
  };

  const handleCloseMasse = () => {
    setOpenMasse(false);
  };

  const updateCheckCredit = async dataCredit => {
    await dispatch(setMasseList(dataCredit));
  };

  const submitMasseCredit = async (clientId, listMasseCredit) => {
    if (clientId) {
      await dispatch(updateMasseCredit({ clientId, listMasseCredit }));
      toast.success("Lưu thành công");
    } else {
      toast.error("Lưu lỗi!");
    }
  };
  const getDashboard = async () => {
    setLoading(true);
    try {
      const res = await dispatch(statisticData());
      return res.payload;
    } finally {
      setLoading(false);
    }
  };

  return {
    open,
    openOut,
    setOpen,
    handleClose,
    handleOutClose,
    handleOpen,
    handleOpenOut,
    data,
    createCredit,
    getList,
    remove,
    edit,
    loading,
    list,
    openModalDelete,
    handleCloseModalDelete,
    handleOpenModalDelete,
    deleteModalContent,
    deleteId,
    checked,
    handleChecked,
    // creditCategories,
    getCreditCategories,
    getListByClient,
    listByClient,
    metaData,
    openMasse,
    setOpenMasse,
    handleOpenMasse,
    handleCloseMasse,
    getListMasseClient,
    listMasseClient,
    updateCheckCredit,
    submitMasseCredit,
    removeCategory,
    handleOpenCat,
    openCat,
    setOpenCat,
    handleCloseCat,
    dataCat,
    createCreditCat,
    creditDetail,
    editCategory,
    credit,
    getListTransactions,
    listTrans,
    loadingDetail,
    updateListTrans,
    updateTransaction,
    handleOpenEdit,
    handleCloseEdit,
    openEdit,
    dataEdit,
    tab,
    creditClose,
    listOnTime,
    listDelay,
    getCreditOnTime,
    getCreditDelay,
    creditPayFast,
    creditTransform,
    getDashboard,
    statistic
  };
};

export default useCreditManagement;
